export default __webpack_public_path__ + "static/media/empty-state-sector-defects.16f27317.svg";